import(/* webpackMode: "eager" */ "D:\\BDT apps\\website_bdt\\website-template\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\careers\\CareersForm.tsx");
